import moment from 'moment';
import { MovieAsset } from '../titles/types/asset';
import { PlayableTitle } from '../titles/types/title';

interface FindPlaybackOptionOptions {
  platformTitleId: string;
  providerIdentifier?: string;
}

export function findPlaybackOption(title: PlayableTitle, options: FindPlaybackOptionOptions) {
  return title.playbackOptions.find((po) => {
    if (options.providerIdentifier !== undefined) {
      return po.platformTitleId === options.platformTitleId && po.providerIdentifier === options.providerIdentifier;
    }

    return po.platformTitleId === options.platformTitleId;
  });
}

export function hasPastMovieProgramPlaybackOption(asset: MovieAsset) {
  const now = moment();
  const pastProgram = asset.playbackOptions.find((po) => moment(po.availableFrom).isBefore(now));
  if (!pastProgram) {
    return false;
  }
  return pastProgram.serviceType === 'program';
}

export function hasFutureMovieProgramPlaybackOption(asset: MovieAsset) {
  const now = moment();
  const futureProgram = asset.playbackOptions.find((po) => moment(po.availableFrom).isAfter(now));
  if (!futureProgram) {
    return false;
  }
  return futureProgram.serviceType === 'program';
}
